<template>
<div class="mt-2 review_bar" style="clear:both;" @click="UpdateReviews()">
    <div style="font-weight:bold;width:20px;float:left;">{{stars}}</div>
    <div style="width:30px;float:left;"><i class="fas fa-star"></i></div>
    <div style="height:10px;width:15.6rem;float:left;background:#eaeaea;position:relative;top:7px;border-radius:20px;">
        <div :style="`height:inherit;background:${color};width:${percent}%;border-radius:inherit;`"></div>
    </div>
    <div style="width:20px;float:right;">{{count}}</div>
<div style="clear:both;"></div>
</div>
</template> 

<script>
import { EventBus } from '../bus';
export default {
  
  props: ['stars','color','percent','count'],

  methods: {
    UpdateReviews() {
      EventBus.$emit('update-reviews', this.stars);
    }
  }

};
</script>